import { createReducer, on } from '@ngrx/store';
import {
  addVehicles,
  addVehiclesFailed,
  editVehicles,
  getVehicles,
  getVehiclesReceived,
  submitForReviewPopup,
  submitVehicleForReview,
  submitVehicleForReviewFailed,
} from '../actions/vehicleActions';
import { vehicleStateDataType } from '../../core/models/Interfaces/vehicle';

const initialState: vehicleStateDataType = {
  isFetchingComments: false,
  commentsData: null,
  isFetchingVehicles: false,
  vehiclesData: null,
  isFetchingVehicleDetails: false,
  submitForReviewData: null,
};

export const vehicleReducer = createReducer(
  initialState,
  on(addVehicles, (state) => {
    return { ...state, isFetchingVehicles: true };
  }),
  on(getVehicles, (state) => {
    return { ...state, isFetchingVehicles: true };
  }),
  on(editVehicles, (state) => {
    return { ...state, isFetchingVehicleDetails: true };
  }),
  on(getVehiclesReceived, (state, data) => {
    return {
      ...state,
      isFetchingVehicles: false,
      vehiclesData: data.params,
      isFetchingVehicleDetails: false,
    };
  }),
  on(addVehiclesFailed, (state) => {
    return { ...state, isFetchingVehicles: false };
  }),
  on(submitVehicleForReview, (state) => {
    return { ...state };
  }),
  on(submitVehicleForReviewFailed, (state) => {
    return { ...state };
  }),
  on(submitForReviewPopup, (state, data) => {
    return {
      ...state,
      submitForReviewData: data.params,
    };
  }),
);
